<template>
  <div id="mirrorDemo" class="mirrorDemo">
    <MirrorHeader id="mirrorDemo__header" title="DEMONSTRATION" />
    <canvas id="mirrorDemo__canvas" class="mirrorDemo__canvas">
      このブラウザはCanvasがサポートされていないため表示できません
    </canvas>
    <ul class="mirrorDemo__list">
      <li class="mirrorDemo__list__item" :class="{ 'is-active': isActiveSize === 'small' }" @click="changeScale(0.5, 'small')">S</li>
      <li class="mirrorDemo__list__item" :class="{ 'is-active': isActiveSize === 'medium' }" @click="changeScale(1.0, 'medium')">M</li>
      <li class="mirrorDemo__list__item" :class="{ 'is-active': isActiveSize === 'large' }" @click="changeScale(1.5, 'large')">L</li>
      <router-link
        :to="{ name: 'mirror-custom', query: { customid: customID } }"
        tag="li"
        class="mirrorDemo__list__item mirrorDemo__list__item--close">
        <img src="@/assets/images/mirror/demo/demo-close.svg" alt="Close">
      </router-link>
    </ul>
    <ScreenSaverModal
      v-if="isScreenSaver"
      @closeScreenSaver="isScreenSaver = false" />
  </div>
</template>

<script>
import MirrorHeader from '@/components/mirror/MirrorHeader'
import ScreenSaverModal from '@/components/mirror/ScreenSaverModal'
import ScreenSaver from '@/assets/class/ScreenSaver'
import createjs from 'createjs'
import customMgr from '@/modules/CustomManager'

export default {
  mixins: [ScreenSaver],
  components: {
    MirrorHeader,
    ScreenSaverModal
  },
  beforeRouteEnter (to, from, next) {
    customMgr.getCustomItem(String(to.params.customID)).then((customItem) => {
      next(vm => vm.setCustomItem(customItem))
    })
  },
  props: {
    customID: String
  },
  data () {
    return {
      customItem: {},
      stage: null,
      bitmap: null,
      isScale: 0.5,
      isActiveSize: 'small'
    }
  },
  methods: {
    setCustomItem (customItem) {
      this.customItem = customItem
    },
    changeScale (scaleValue, scaleLabel) {
      this.isActiveSize = scaleLabel
      this.isScale = scaleValue
      this.bitmap.scaleX = this.isScale
      this.bitmap.scaleY = this.isScale
    }
  },
  created () {
    this.$nextTick(() => {
      this.stage = new createjs.Stage('mirrorDemo__canvas')
      createjs.Touch.enable(this.stage)
      createjs.Ticker.addEventListener('tick', this.stage)
      this.stage.canvas.width = window.innerWidth
      this.stage.canvas.height = window.innerHeight - document.getElementById('mirrorDemo__header').clientHeight
      const queue = new createjs.LoadQueue(true)
      queue.loadFile(this.customItem.customImage[0].filename)
      queue.on('fileload', (flEvent) => {
        this.bitmap = new createjs.Bitmap(flEvent.result)
        this.bitmap.regX = this.bitmap.image.width / 2
        this.bitmap.regY = this.bitmap.image.height / 2
        this.bitmap.x = this.stage.canvas.width / 2
        this.bitmap.y = this.stage.canvas.height / 2
        this.bitmap.scaleX = this.isScale
        this.bitmap.scaleY = this.isScale
        this.stage.addChild(this.bitmap)

        let dragPointX, dragPointY

        this.bitmap.addEventListener('mousedown', (mdEvent) => {
          dragPointX = this.stage.mouseX - this.bitmap.x
          dragPointY = this.stage.mouseY - this.bitmap.y
          mdEvent.stopPropagation()
        }, false)

        this.bitmap.addEventListener('pressmove', (pmEvent) => {
          this.bitmap.x = this.stage.mouseX - dragPointX
          this.bitmap.y = this.stage.mouseY - dragPointY
          pmEvent.stopPropagation()
        }, false)
      }, false)
    })
  }
}
</script>

<style lang="scss" scoped>
.mirrorDemo {
  background-color: #000000;
  &__list {
    color: $base-white;
    position: absolute;
    top: 40%;
    right: 6vw;
    font-size: 28px;
    &::before {
      content: "ITEM ZOOM";
      position: absolute;
      display: block;
      top: -90px;
      width: 160px;
      left: -30px;
      font-size: 24px;
      transform: rotate(90deg);
    }
    &__item {
      width: 100px;
      height: 100px;
      background-color: #333333;
      margin-bottom: 10px;
      border-radius: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      &--close {
        margin-top: 40px;
        position: relative;
        &::before {
          content: "";
          display: block;
          width: 100%;
          height: 1px;
          background: #CCC;
          position: absolute;
          top: -20px;
        }
        img {
          width: 30%;
        }
      }
      &.is-active {
        background-color: #dddddd;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/mirror/MirrorDemo.vue